const LangCardReload = {
	"cardReload.yourCardHasBeenSuccessfullyReloaded": [
		"YAY! Your card has been successfully reloaded.",
		"Thẻ của bạn đã được nạp tiền thành công.",
	],
	"cardReload.chooseAnAmount": ["Choose an amount", "Chọn số tiền mặc định"],
	"cardReload.cardBalance": ["Card Balance", "Số dư trên thẻ"],
	"cardReload.orInputYourOwnAmount": ["Or input your own amount", "Hoặc số tiền khác"],
	"cardReload.myCardName": ["My card name", "Tên thẻ"],
	"cardReload.newBalance": ["New Balance", "Số dư mới"],
	"cardReload.amtIsNotInRange": [
		"Please enter a value amount between 50,000-5,000,000 and a maximum 5,000,000 can be stored in one Card at any one time",
		"Vui lòng chọn số tiền từ 50,000 đến 5,000,000đ. Tối đa số dư được phép trên mỗi thẻ là 5,000,000",
	],
	"cardReload.amtIsNotMultipleOf1000": [
		"The amount to be purchased should only be in denomination of VND 1,000",
		"Số tiền không hợp lệ, số tiền được chọn phải là bội số của VND 1,000",
	],
}

export default LangCardReload



// WEBPACK FOOTER //
// ./src/resources/pages/LangCardReload.js